(function() { window.GUID_fa50bcca_78b5_4582_a4de_9c85779dbc25 = { getGuid: function() { return "fa50bcca-78b5-4582-a4de-9c85779dbc25"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let MainFilterSubPanelType;
        (function (MainFilterSubPanelType) {
            MainFilterSubPanelType[MainFilterSubPanelType["Persona"] = 0] = "Persona";
            MainFilterSubPanelType[MainFilterSubPanelType["Event"] = 1] = "Event";
            MainFilterSubPanelType[MainFilterSubPanelType["DivisionBracket"] = 2] = "DivisionBracket";
        })(MainFilterSubPanelType = Enumeration.MainFilterSubPanelType || (Enumeration.MainFilterSubPanelType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=MainFilterSubPanelType.pre.js.map
